<template>
  <div class="mx-5 px-5">
    <RecursiveILOsCheckbox
      @ilo-checkbox-change="onChangeCheckBox"
      :items="Object.values(ilos)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { FlexibleILOs, FlexibleILOsData } from '@/types/ilos.type';
import RecursiveILOsCheckbox from './RecursiveILOsCheckbox.component.vue';

export default defineComponent({
  name: 'SubjectFlexibleILOs',
  components: {
    RecursiveILOsCheckbox,
  },
  props: {
    items: {
      type: Object as PropType<FlexibleILOs>,
      required: true,
    },
  },
  data() {
    return {
      ilos: {} as FlexibleILOs,
    };
  },
  mounted() {
    this.ilos = JSON.parse(JSON.stringify(this.items));
  },
  methods: {
    onChangeCheckBox(props: { isSelected: boolean; item: FlexibleILOsData }): void {
      this.onChangeItemChidrenRec(props.isSelected, [props.item]);
      this.$emit('update-flexible-ilos', JSON.parse(JSON.stringify(this.ilos)));
    },
    onChangeItemChidrenRec(isSelected: boolean, item: FlexibleILOsData[]): void {
      item.forEach((subItem) => {
        // eslint-disable-next-line no-param-reassign
        subItem.selected = isSelected;
        if (subItem.children && Object.values(subItem.children).length > 0) {
          this.onChangeItemChidrenRec(isSelected, Object.values(subItem.children));
        }
      });
    },
  },
});
</script>

<style scoped></style>
